module.exports = __webpack_public_path__ + "img/discord.496f7930.svg";